module.exports = __webpack_public_path__ + "img/bosspack_cod_k.bf64a1c4.png";